import { render, staticRenderFns } from "./BodyCont.vue?vue&type=template&id=69782c62&scoped=true"
var script = {}
import style0 from "./BodyCont.vue?vue&type=style&index=0&id=69782c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69782c62",
  null
  
)

export default component.exports